export default {
  methods: {
    displayNotification(
      message,
      type = "is-danger",
      position = "is-bottom-right",
      duration = 3000
    ) {
      this.$buefy.notification.open({
        duration,
        message,
        position,
        type,
        hasIcon: false,
        queue: false
      });
    }
  }
};
